var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.297,
    width: 33.79,
    height: 40.548,
    rx: 16.895,
    fill: "#FFE6E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.864 16.348l-8.192 8.191M12.671 16.348c2.517.682 8.192 0 8.192 0s-.683 5.676 0 8.192",
    stroke: "#D3433C",
    strokeWidth: 1.267
  })));
}
export default SvgCtaIcon;